<!-- <div class="orders">
  <div class="order_block track_orders">
    <h3 i18n="@@orders.track_orders">Track orders</h3>
    <order-detail 
      [orders]="orders" 
      [paginator]="paginator" 
      (perPageItems)="onChangePerPageItems($event)"
      (onPageChange)="getPage($event)" 
      (sortRequested)="fetchOrders($event.column, $event.direction)">
    </order-detail>
  </div>
  <div class="order_block order_history">
    <h3 i18n="@@orders.order_history">Order history</h3>
    <order-detail 
      [orders]="orders" 
      [paginator]="paginator" 
      (perPageItems)="onChangePerPageItems($event)"
      (onPageChange)="getPage($event)" 
      (sortRequested)="fetchOrders($event.column, $event.direction)">
    </order-detail>
  </div>
</div> -->

<!-- <div class="orders">
  <div class="order_block track_orders">
    <h3>
      <ng-container i18n="@@orders.track_orders">Track orders</ng-container>
    </h3>
    <ng-container *ngFor="let order of trackOrders">
      <order-detail-accordion
        [order]="order"
        [products]="order.products">
      </order-detail-accordion>
    </ng-container>
  </div>
  <div class="order_block order_history">
    <h3>
      <ng-container i18n="@@orders.order_history">Order history</ng-container>
    </h3>
    <ng-container *ngFor="let order of completedOrders">
      <order-detail-accordion
        [order]="order"
        [products]="order.products">
      </order-detail-accordion>
    </ng-container>
  </div>
</div> -->

<div class="orders">
  <div class="order_block track_orders">
    <div class="d-flex w-100">
      <h3 i18n="@@orders.track_orders">Track orders</h3>
      <a href="/storefronts" class="btn w-auto text-white" i18n="@@orders.order_now">Order now</a>
    </div>
    <order-detail 
      [tableSection]="'track_order'">
    </order-detail>
  </div>
  <div class="order_block order_history">
    <h3 i18n="@@orders.order_history">Order history</h3>
    <order-detail 
      [tableSection]="'order_history'">
    </order-detail>
  </div>
</div>